<template>
    <div id="bene-bank-transfer-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                v-if         ="showFormInput.bankTransfer.bankBranch"
                :label       ="$t('beneficiary-bank-branch')"
                :placeholder ="$t('beneficiary-select-bank-branch')"
                :value       ="bankBranch"

                disabled
                outline
                floating-label
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
        ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bankBranch',
                'bankBranchId',-
                'showPreloaderState',
                'forceRerenderKey',
                'isCreateBeneficiary',
            ])
        },
        components: {
        },
        methods: {
            ...mapActions('beneficiary', [
                'setShowPreloaderState'
            ])
        }
    }
</script>